import {
  DAYS_IN_MONTH,
  MAXIMUM_AGE,
  MIN_AGE,
  MONTHS_IN_YEAR,
  VALUE_ONE,
  VALUE_TWO,
} from './consts'

export interface DateEntry {
  text: string
  value: number
}

export const dateOfBirthGetDays = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const days: DateEntry[] = [
    ...Array.from({ length: DAYS_IN_MONTH }).keys(),
  ].map((day) => ({
    text: `${day + VALUE_ONE}`.padStart(VALUE_TWO, '0'),
    value: day + VALUE_ONE,
  }))

  if (includePlaceholder) {
    days.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return days
}

export const dateOfBirthGetMonths = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const months: DateEntry[] = [
    ...Array.from({ length: MONTHS_IN_YEAR }).keys(),
  ].map((month) => ({
    text: `${month + VALUE_ONE}`.padStart(VALUE_TWO, '0'),
    value: month + VALUE_ONE,
  }))

  if (includePlaceholder) {
    months.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return months
}

export const dateOfBirthGetYears = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const currentYear = new Date().getFullYear()
  const yearsToCount = MAXIMUM_AGE - MIN_AGE + 1
  const years: DateEntry[] = [
    ...Array.from({ length: yearsToCount }).keys(),
  ].map((year) => ({
    text: `${currentYear - year - MIN_AGE}`,
    value: currentYear - year - MIN_AGE,
  }))

  if (includePlaceholder) {
    years.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return years
}
